export const checkValidUrl = (url: string): boolean => {
  let urlCheck: string = url;
  if (url.includes("www")) urlCheck = url.split("www.")[1];

  if (urlCheck && urlCheck.includes(".")) {
    const urlAux = urlCheck.split(".");
    if (urlAux[0].length > 0) urlCheck = urlAux[urlAux.length - 1];
    else return false;
  } else return false;

  if (urlCheck.length >= 2 && urlCheck.length <= 3) return true;

  return false;
};
